import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[phoneInput]'
})
export class PhoneInputDirective implements OnInit, OnChanges, OnDestroy {
    @Input() phoneInputDial: string;
    @Input() phoneInputCc: string;

    subscription = new Subscription();
    constructor(private el: ElementRef, private ngModel: NgModel) {
    }

    ngOnInit(): void {
        this.subscription.add(this.ngModel.valueChanges.subscribe((value) => {
            this.updateValue(value);
        }));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['phoneInputDial']) {
            let value: string = this.ngModel.value;
            if (!value) {
                return;
            }
            value = value.replace("+" + changes['phoneInputDial'].previousValue, "");
            this.updateValue(value);
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private format(value: string): string {
        const regExp = /[^\d^+]/g;
        const parsedPn = value.replace(regExp, '');

        if (!parsedPn) return '';

        let formattedPn = parsedPn.trim().charAt(0) === '+' ? parsedPn : `+${this.phoneInputDial}${parsedPn}`;

        return formattedPn;
    }

    updateValue(value: string): void {
        if (!value) {
            return;
        }
        const formattedValue = this.format(value);
        this.ngModel.viewToModelUpdate(formattedValue);
        this.el.nativeElement.value = formattedValue;

    }
}
